import React, { useState } from "react";
import { Tooltip } from "antd";
import somethingWentWrong from "../../../../assets/No_Data_Found.svg";
import InfoIcon from "../../../../assets/Info_Icon.svg";
import { kFormatter } from "../../../../redux/constants";

const TotalTicket = ({ totalsTicketwidget, id }) => {
  const [totalTicket, settotalTicket] = useState({
    text: "Show Details",
    toggle: false,
  });

  const showTicket = (e) => {
    if (e) {
      settotalTicket({ text: "Hide Details", toggle: true });
    } else {
      settotalTicket({ text: "Show Details", toggle: false });
    }
  };

  return totalsTicketwidget?.data ? (
    <>
      {" "}
      <div className="row ml-0 mr-0">
        <div className="col-12 col-md-4 text-center border-right">
          <div className="wm-chart-card-title pt-15 mb-2">
            {totalsTicketwidget?.data[1]?.text}
            {id === "tickets_simple-view_2" && (
              <Tooltip
                title="These tickets were either created or updated during the selected duration and are still in agent's queue or are unactioned by the user."
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
            {id === "tickets_simple-view_6" && (
              <Tooltip
                title="These are the tickets which are either waiting in queue to be assigned or not responded to by the Agent in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
          </div>
          <div className="wm-chart-card-value pb-2">
            <Tooltip
              title={totalsTicketwidget?.data[1]?.value?.toLocaleString()}
              placement="bottom"
            >
              {kFormatter(totalsTicketwidget?.data[1]?.value)}
            </Tooltip>
          </div>

          <div
            className={`row bg__grey-lightNew border-top ${
              totalTicket?.toggle ? "" : "d-none"
            }`}
          >
            <div className="col-12 col-md-6 text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[1]?.data[0]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[1]?.data[0]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[1]?.data[0]?.value)}
                </Tooltip>
              </div>
            </div>
            <div className="col-12 col-md-6 border-left text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[1]?.data[1]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[1]?.data[1]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[1]?.data[1]?.value)}
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 text-center border-right">
          <div className="wm-chart-card-title pt-15 mb-2">
            {totalsTicketwidget?.data[2]?.text}
            {id === "tickets_simple-view_2" && (
              <Tooltip
                title="These are the tickets which are either on hold, escalated or awaiting customer response"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
            {id === "tickets_simple-view_6" && (
              <Tooltip
                title="These are the tickets which are either on hold, escalated or awaiting customer response in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
          </div>
          <div className="wm-chart-card-value pb-2">
            <Tooltip
              title={totalsTicketwidget?.data[2]?.value?.toLocaleString()}
              placement="bottom"
            >
              {kFormatter(totalsTicketwidget?.data[2]?.value)}
            </Tooltip>
          </div>

          <div
            className={`row border-top bg__grey-lightNew ${
              totalTicket?.toggle ? "" : "d-none"
            }`}
          >
            <div className="col-12 col-md-4 text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[2]?.data[0]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[2]?.data[0]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[2]?.data[0]?.value)}
                </Tooltip>
              </div>
            </div>
            <div className="col-12 col-md-4 border-left text-center">
              <div
                className="wm-chart-card-title  pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[2]?.data[1]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[2]?.data[1]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[2]?.data[1]?.value)}
                </Tooltip>
              </div>
            </div>
            <div className="col-12 col-md-4 border-left text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[2]?.data[2]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[2]?.data[2]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[2]?.data[2]?.value)}
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 text-center">
          <div className="wm-chart-card-title pt-15 mb-2">
            {totalsTicketwidget?.data[3]?.text}
            {id === "tickets_simple-view_2" && (
              <Tooltip
                title="These are the tickets which are closed in selected duration"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
            {id === "tickets_simple-view_6" && (
              <Tooltip
                title="These are the tickets which are closed in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
          </div>
          <div className="wm-chart-card-value pb-2">
            <Tooltip
              title={totalsTicketwidget?.data[3]?.value?.toLocaleString()}
              placement="bottom"
            >
              {kFormatter(totalsTicketwidget?.data[3]?.value)}
            </Tooltip>
          </div>

          <div
            className={`row border-top bg__grey-lightNew ${
              totalTicket?.toggle ? "" : "d-none"
            }`}
          >
            <div className="col-12 col-md-4 text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[3]?.data[0]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[3]?.data[0]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[3]?.data[0]?.value)}
                </Tooltip>
              </div>
            </div>
            <div className="col-12 col-md-4 border-left text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[3]?.data[1]?.text}
              </div>
              <div className="wm-chart-card-value pb-15 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[3]?.data[1]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[3]?.data[1]?.value)}
                </Tooltip>
              </div>
            </div>
            <div className="col-12 col-md-4 border-left text-center">
              <div
                className="wm-chart-card-title pt-15 mb-2"
                style={{ minHeight: "5rem" }}
              >
                {totalsTicketwidget?.data[3]?.data[2]?.text}
              </div>
              <div className="wm-chart-card-value pb-0 mb-0">
                <Tooltip
                  title={totalsTicketwidget?.data[3]?.data[2]?.value?.toLocaleString()}
                  placement="bottom"
                >
                  {kFormatter(totalsTicketwidget?.data[3]?.data[2]?.value)}
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="text_regular showTicket border-top cursor-pointer text-center pt-15 pb-15"
        onClick={() => showTicket(!totalTicket?.toggle)}
      >
        {totalTicket?.text}
      </div>
    </>
  ) : (
    <div className="portlet_images text-center p-15 col-12">
      <img
        alt="no data"
        src={somethingWentWrong}
        style={{ maxWidth: "100%", minWidth: "20rem", marginTop: "1.5rem" }}
      />
      <p className="mt-15 text_regular-gray">No Data Found</p>
    </div>
  );
};

export default TotalTicket;
